// src/pages/ManageContent.js
import React, { useState } from 'react';
import '../styles/SuitcaseTheatreArcadeStyle.css';
import EventUploader from './EventUploader';
import UploadMedia from './UploadMedia';
import ManageStoreEmbeds from './StoreManager';
import StoreManager from "./StoreManager"; // ← new import

const SuitcaseTheatreArcadeDashboard = () => {
    const [activeTab, setActiveTab] = useState('events');

    return (
        <div className="event-uploader-container">
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
                <button
                    className={activeTab === 'events' ? 'event-uploader-submit-button' : ''}
                    onClick={() => setActiveTab('events')}
                >
                    Manage Events
                </button>
                <button
                    className={activeTab === 'media' ? 'event-uploader-submit-button' : ''}
                    onClick={() => setActiveTab('media')}
                >
                    Manage Media
                </button>
                <button
                    className={activeTab === 'store' ? 'event-uploader-submit-button' : ''}
                    onClick={() => setActiveTab('store')}
                >
                    Manage Store
                </button>
            </div>

            {activeTab === 'events' && <EventUploader />}
            {activeTab === 'media' && <UploadMedia />}
            {activeTab === 'store' && <StoreManager />}
        </div>
    );
};

export default SuitcaseTheatreArcadeDashboard;
